<template>
  <div
    v-if="visible"
    class="tw-z-30 tw-fixed tw-inset-0 tw-flex tw-flex-col tw-text-white"
  >
    <div
      class="tw-z-20 tw-opacity-95 tw-fixed tw-inset-0 previewOverlayBg"
    ></div>

    <div
      class="tw-relative tw-z-30 tw-flex tw-flex-col tw-h-screen tw-px-8 tw-pt-8 tw-pb-8"
    >
      <div class="tw-text-center tw-flex-none">
        <div class="tw-text-5xl tw-font-bold">Confira suas fotos</div>
        <div class="tw-text-3xl tw-mt-2 tw-w-4/5 tw-mx-auto">
          Valide as imagens antes de continuar para a impressão.
        </div>
        <div
          v-if="erroPreviewFinal"
          class="tw-text-2xl tw-mt-4 tw-text-red-200 tw-font-semibold"
          data-cy="erro-preview"
        >
          {{ erroPreviewFinal }}
        </div>
      </div>

      <div
        v-if="fotosComProblema.length > 0"
        class="tw-mt-4 tw-bg-yellow-400 tw-text-yellow-900 tw-rounded-xl tw-px-6 tw-py-4 tw-text-2xl tw-font-semibold tw-shadow-lg"
      >
        <div class="tw-flex tw-items-center tw-gap-3">
          <v-icon size="32" color="#78350f">mdi-alert</v-icon>
          <span>
            {{
              fotosComProblema.length === 1
                ? `A foto ${
                    fotosComProblema[0] + 1
                  } pode ter ficado com problema.`
                : `As fotos ${fotosComProblema
                    .map((i) => i + 1)
                    .join(", ")} podem ter ficado com problema.`
            }}
          </span>
        </div>
        <div class="tw-text-xl tw-mt-2 tw-font-normal">
          Deseja corrigir antes de continuar, ou prefere continuar mesmo assim?
        </div>
      </div>

      <div
        class="tw-flex-1 tw-min-h-0 tw-mt-6 tw-overflow-y-auto tw-pr-2 scroll-modern"
      >
        <div
          class="tw-grid tw-gap-6"
          :class="
            listaPreviewsFinais.length > 1 ? 'tw-grid-cols-2' : 'tw-grid-cols-1'
          "
        >
          <div
            v-for="preview in listaPreviewsFinais"
            :key="`preview-${preview.index}`"
            class="tw-bg-white tw-rounded-xl tw-p-4 tw-shadow-2xl"
            :class="{ 'tw-ring-4 tw-ring-yellow-400': preview.comProblema }"
          >
            <div
              class="tw-text-black tw-font-semibold tw-text-xl tw-mb-3 tw-flex tw-items-center tw-justify-between"
            >
              <span>Foto {{ preview.index + 1 }}</span>
              <span
                v-if="preview.comProblema"
                class="tw-text-yellow-600 tw-text-base tw-flex tw-items-center tw-gap-1"
              >
                <v-icon size="18" color="#ca8a04">mdi-alert</v-icon> Problema
                detectado
              </span>
            </div>
            <!-- ph-no-capture: preview final não entra na gravação de sessão. -->
            <div
              class="ph-no-capture tw-bg-gray-100 tw-rounded-lg tw-p-2"
              :class="{ 'tw-p-5 tw-pb-16 tw-bg-white': tipo == 'polaroid' }"
            >
              <img
                v-if="preview.folhaDataUrl"
                :src="preview.folhaDataUrlDisplay || preview.folhaDataUrl"
                class="tw-w-full tw-h-96 tw-object-contain tw-rounded"
                draggable="false"
                @contextmenu.prevent
                @dragstart.prevent
              />
              <img
                v-else
                :src="preview.imagemDataUrlDisplay || preview.imagemDataUrl"
                :class="[
                  'tw-w-full tw-object-contain tw-rounded',
                  preview.orientacao === 'PAISAGEM' ? 'tw-h-48' : 'tw-h-72',
                ]"
                draggable="false"
                @contextmenu.prevent
                @dragstart.prevent
              />
            </div>
            <div
              v-if="preview.folhaDataUrl"
              class="tw-text-gray-600 tw-text-lg tw-mt-2 tw-text-center"
            >
              4 fotos 5 x 7cm na mesma folha
            </div>
            <div class="tw-mt-4 tw-text-right">
              <button
                class="btnCorrigirFoto"
                @click="$emit('corrigir-foto', preview.index)"
                :disabled="loadingFinalizar"
              >
                Corrigir esta foto
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="tw-flex-none tw-mt-6">
        <div class="tw-w-full tw-text-3xl">
          <button
            class="btnAcaoPrincipal tw-uppercase tw-rounded-xl tw-border-4 tw-p-4 tw-w-full tw-border-solid"
            @click="$emit('confirmar')"
            :disabled="loadingFinalizar"
          >
            <div v-if="loadingFinalizar" class="tw-text-center">
              <v-icon size="42" color="white" class="tw-animate-spin"
                >mdi-loading</v-icon
              >
            </div>
            <div v-else>
              <span v-if="isSkipPaymentStep">CONFIRMAR E IMPRIMIR</span>
              <span v-else>CONFIRMAR E IR PARA PAGAMENTO</span>
            </div>
          </button>
        </div>

        <div
          class="tw-w-full tw-mt-4 tw-text-2xl tw-grid tw-grid-cols-2 tw-gap-4"
        >
          <button
            class="tw-uppercase tw-rounded-xl tw-border-2 tw-p-4 tw-w-full tw-border-white tw-border-solid"
            @click="$emit('tentar-novamente')"
            :disabled="loadingFinalizar"
          >
            Tentar novamente
          </button>
          <button
            class="tw-uppercase tw-rounded-xl tw-border-2 tw-p-4 tw-w-full tw-border-white tw-border-solid"
            @click="$emit('voltar-edicao')"
            :disabled="loadingFinalizar"
          >
            Voltar para edição
          </button>
        </div>

        <!-- A folha falhou por falta de memória várias vezes seguidas: só
             recarregar o totem resolve. -->
        <button
          v-if="mostrarReiniciar"
          class="tw-uppercase tw-rounded-xl tw-border-2 tw-p-4 tw-w-full tw-mt-4 tw-text-2xl tw-border-white tw-border-solid"
          data-cy="reiniciar-totem"
          @click="$emit('reiniciar')"
          :disabled="loadingFinalizar"
        >
          Reiniciar totem
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "vPreview",
  computed: {
    fotosComProblema() {
      return this.listaPreviewsFinais
        .filter((p) => p.comProblema)
        .map((p) => p.index);
    },
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    erroPreviewFinal: {
      type: String,
      default: "",
    },
    listaPreviewsFinais: {
      type: Array,
      default: () => [],
    },
    tipo: {
      type: String,
      default: "",
    },
    loadingFinalizar: {
      type: Boolean,
      default: false,
    },
    isSkipPaymentStep: {
      type: Boolean,
      default: false,
    },
    mostrarReiniciar: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.previewOverlayBg {
  background: linear-gradient(180deg, #8c2667 0%, #222129 100%);
}

.btnCorrigirFoto {
  @apply tw-uppercase tw-rounded-lg tw-border-2 tw-border-black tw-px-5 tw-py-2 tw-bg-black tw-text-white tw-font-semibold tw-shadow-md tw-transition tw-duration-150 tw-ease-in-out;
}

.btnCorrigirFoto:hover:not(:disabled) {
  @apply tw-bg-gray-900 tw-shadow-lg;
  transform: translateY(-1px);
}

.btnCorrigirFoto:active:not(:disabled) {
  @apply tw-shadow;
  transform: translateY(0);
}

.btnCorrigirFoto:disabled {
  @apply tw-opacity-50 tw-cursor-not-allowed;
}

.btnAcaoPrincipal {
  border-color: #8c2667;
  background-color: #8c2667;
  color: #ffffff;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  transition: background-color 0.15s ease, transform 0.15s ease,
    box-shadow 0.15s ease;
}

.btnAcaoPrincipal:hover:not(:disabled) {
  background-color: #651946;
  border-color: #651946;
  transform: translateY(-1px);
  box-shadow: 0 14px 24px rgba(0, 0, 0, 0.24);
}

.btnAcaoPrincipal:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 8px 14px rgba(0, 0, 0, 0.18);
}

.btnAcaoPrincipal:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
</style>
